import part1 from './preparationQuestionDraftPacks/arabic-bengali-spanish-farsi.js';
import part2 from './preparationQuestionDraftPacks/french-gujarati-italian-punjabi.js';
import part3 from './preparationQuestionDraftPacks/polish-portuguese-romanian-somali.js';
import part4 from './preparationQuestionDraftPacks/tagalog-turkish-urdu-chinese.js';
import { PREPARATION_QUESTIONS_ENGLISH } from './preparationQuestionsCopy.js';

// Explicit MACHINE DRAFT only. No translated clinical advice is live until
// the independent source-current, professionally approved Studio release has
// all 21 texts. These initial drafts are visible for review, not certification.
const draftArrays = Object.freeze({ ...part1, ...part2, ...part3, ...part4 });
function flatten(value, prefix = '') {
  return Object.entries(value).flatMap(([key, item]) => {
    const path = prefix ? prefix + '.' + key : key;
    return item && typeof item === 'object' && !Array.isArray(item)
      ? flatten(item, path) : [{ path, source: item }];
  });
}
export const PREPARATION_QUESTION_DRAFT_SOURCE_ROWS =
  Object.freeze(flatten(PREPARATION_QUESTIONS_ENGLISH));
export const PREPARATION_QUESTION_DRAFT_LANGUAGES =
  Object.freeze(Object.keys(draftArrays).sort());
const keyCount = PREPARATION_QUESTION_DRAFT_SOURCE_ROWS.length;
export const PREPARATION_QUESTION_MACHINE_DRAFTS = Object.freeze(
  Object.fromEntries(Object.entries(draftArrays).map(([language, values]) => {
    if (!Array.isArray(values) || values.length !== keyCount)
      throw new Error('Incomplete machine draft preparation pack: ' + language);
    return [language, Object.freeze(Object.fromEntries(values.map((text, index) =>
      [PREPARATION_QUESTION_DRAFT_SOURCE_ROWS[index].path, text])))];
  }))
);
const languageId = value => String(value || '').toLowerCase().split('-')[0];

export function preparationQuestionMachineDraftFor(language, path) {
  return PREPARATION_QUESTION_MACHINE_DRAFTS[languageId(language)]?.[path];
}
export function installPreparationQuestionMachineDrafts(i18n, language, namespace) {
  if (namespace !== 'hospitalJourney') return;
  const locale = languageId(language);
  const drafts = PREPARATION_QUESTION_MACHINE_DRAFTS[locale];
  if (!drafts) return;
  for (const [path, text] of Object.entries(drafts)) {
    const key = 'ui.preparationQuestions.' + path;
    const existing = i18n.getResource(locale, namespace, key);
    // Reviewed locale files always win; machine drafts fill absent keys only.
    if (typeof existing !== 'string' || !existing.trim())
      i18n.addResource(locale, namespace, key, text);
  }
}
